// extracted by mini-css-extract-plugin
module.exports = {"empty":"mobile_empty___HOug","emptyDesc":"mobile_emptyDesc__nt3ro"};